import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop, PropType } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'
import { WebhookConfig } from './WebhookConfig'
import { WebhookEventEnum } from './WebhookEventEnum'
import { WebhookDeliveryStatusEnum } from './WebhookDeliveryStatusEnum'
import { RelatedEntity } from '../base/RelatedEntity'
import { BaseEntity } from '../base/BaseEntity'
import { WebhookError } from './WebhookError'
import GraphQLJSON from 'graphql-type-json'

@ObjectType()
@InputType('WebhookDeliveryInput')
@modelOptions({ schemaOptions: { timestamps: true } })
export class WebhookDelivery extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('whd') })
  declare _id: string

  @Field(() => WebhookConfig)
  @Prop({ type: RelatedEntity, required: true })
  webhookConfig?: WebhookConfig

  @Field(() => WebhookEventEnum)
  @Prop({ type: String, enum: WebhookEventEnum, required: true, index: true })
  event: string

  /**
   * The payload of the webhook, we can put anything here, we can even put this on the job payload
   */
  @Field(() => GraphQLJSON)
  @Prop({ type: () => WebhookDeliveryPayload })
  payload: any

  @Field(() => WebhookDeliveryStatusEnum)
  @Prop({
    type: String,
    enum: WebhookDeliveryStatusEnum,
    required: true,
    index: true,
    default: WebhookDeliveryStatusEnum.pending,
  })
  declare status?: string

  @Field(() => Number)
  @Prop({ type: Number, default: 0 })
  attemptCount?: number

  @Field(() => [WebhookError])
  @Prop({ type: () => [WebhookError] }, PropType.ARRAY)
  errors?: ReturnType<() => WebhookError[]>
}

@ObjectType()
@InputType('WebhookDeliveryPayloadInput')
@modelOptions({ schemaOptions: { strict: false } })
export class WebhookDeliveryPayload {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('whpay') })
  _id: string
}
